module.exports = __webpack_public_path__ + "static/media/oediv-x2.97bec06b.png";